import "../styles/components/_swiper.scss";
import Swiper from "swiper";
import { EffectCoverflow, Navigation, Pagination } from "swiper/modules";

Swiper.use([Navigation, Pagination, EffectCoverflow]);
window.Swiper = Swiper;
